import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = { class: "inline-block" }
const _hoisted_3 = { class: "text-center text-gray-400 py-4 text-sm" }


export default /*@__PURE__*/_defineComponent({
  __name: 'TableLoader',
  props: {
        colspan: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            default: 'Fetching Records'
        }
    },
  setup(__props) {

    

    const loaderClass = [
        "w-8 h-8",
        "rounded-full",
        "border-4",
        "border-gray-200",
        "border-t-primary",
        "animate-spin",
        "mx-auto"
    ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      colspan: __props.colspan,
      class: "pt-10 text-center"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(loaderClass)
        }),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1)
      ])
    ], 8, _hoisted_1)
  ]))
}
}

})